export default __webpack_public_path__ + "static/media/92_desktop.f4a99cb8.jpg";